import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'sku-reports.orders.page-title',
    defaultMessage: 'Order reports',
  },
  earningsTile: {
    id: 'sku-reports.orders.tile-earnings',
    defaultMessage: 'Earnings',
  },
  ordersTile: {
    id: 'sku-reports.orders.tile-orders',
    defaultMessage: 'Orders',
  },
  comparedToLastPeriod: {
    id: 'sku-reports.orders.compared-to-last-period',
    defaultMessage: 'Compared to last period',
  },
  cancelledOrdersTile: {
    id: 'sku-reports.orders.tile-cancelled-orders',
    defaultMessage: 'Cancelled orders',
  },
  ordersCount: {
    id: 'sku-reports.orders.orders-count',
    defaultMessage: '{count, plural, one {# order} other {# orders}}',
  },
  orderIdColumn: {
    id: 'sku-reports.orders.column-order-id',
    defaultMessage: 'Order ID',
  },
  locationColumn: {
    id: 'sku-reports.orders.column-location',
    defaultMessage: 'Location',
  },
  itemsColumn: {
    id: 'sku-reports.orders.column-items',
    defaultMessage: 'Item(s)',
  },
  pickUpTimeColumn: {
    id: 'sku-reports.orders.column-pick-up-time',
    defaultMessage: 'Pick up time',
  },
  customerColumn: {
    id: 'sku-reports.orders.column-customer',
    defaultMessage: 'Customer',
  },
  statusColumn: {
    id: 'sku-reports.orders.column-status',
    defaultMessage: 'Status',
  },
  earningsColumn: {
    id: 'sku-reports.orders.column-earnings',
    defaultMessage: 'Earnings',
  },
  mobileOrderColumn: {
    id: 'sku-reports.orders.column-mobile-order',
    defaultMessage: 'Order ID / Date & time',
  },
  locationLabel: {
    id: 'sku-reports.orders.filter-location-label',
    defaultMessage: 'Location',
  },
  allLocations: {
    id: 'sku-reports.orders.filter-all-locations',
    defaultMessage: 'All locations ({venuesCount})',
  },
  locationsSelected: {
    id: 'sku-reports.orders.filter-locations-selected',
    defaultMessage: '{selectedVenuesCount, plural, one {# location} other {# locations}}',
  },
  dateRangeLabel: {
    id: 'sku-reports.orders.filter-date-range-label',
    defaultMessage: 'Date range',
  },
  previousPeriod: {
    id: 'sku-reports.orders.filter-previous-period',
    defaultMessage: 'Previous period',
  },
  nextPeriod: {
    id: 'sku-reports.orders.filter-next-period',
    defaultMessage: 'Next period',
  },
  last7Days: {
    id: 'sku-reports.orders.filter-last-7-days',
    defaultMessage: 'Last 7 days',
  },
  last30Days: {
    id: 'sku-reports.orders.filter-last-30-days',
    defaultMessage: 'Last 30 days',
  },
  last6Months: {
    id: 'sku-reports.orders.filter-last-6-months',
    defaultMessage: 'Last 6 months',
  },
  allStatuses: {
    id: 'sku-reports.orders.filter-all-statuses',
    defaultMessage: 'All statuses',
  },
  completedStatus: {
    id: 'sku-reports.orders.filter-status-completed',
    defaultMessage: 'Completed',
  },
  cancelledStatus: {
    id: 'sku-reports.orders.filter-status-cancelled',
    defaultMessage: 'Cancelled',
  },
  preparingStatus: {
    id: 'sku-reports.orders.status-preparing',
    defaultMessage: 'Preparing',
  },
  emptyTitle: {
    id: 'sku-reports.orders.empty-title',
    defaultMessage: 'You have no order reports yet',
  },
  emptyBody: {
    id: 'sku-reports.orders.empty-body',
    defaultMessage: 'Order reports will show here once an order has been completed or cancelled',
  },
  errorTitle: {
    id: 'sku-reports.orders.error-title',
    defaultMessage: "We couldn't load your orders",
  },
  errorBody: {
    id: 'sku-reports.orders.error-body',
    defaultMessage: 'Something went wrong on our end. Please try again.',
  },
  retry: {
    id: 'sku-reports.orders.retry',
    defaultMessage: 'Try again',
  },
});
